<template>
<div >
    <vx-card class="no-scroll-content" ref="content" title="List of Filed Overtime" >

        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewOvertime()" icon-pack="feather" icon="icon-file">Apply Overtime</vs-button>
        <vs-table class="no-scroll-content" stripe max-items="12" pagination v-model="selected"  search  :data="getEmployeeOvertimeRequests">

            <template slot="thead">
                <vs-th sort-key="createdOn">Date Applied</vs-th>
                <!-- <vs-th sort-key="overtimeTypeId">Overtime Type</vs-th> -->
                <vs-th sort-key="otDate">Date</vs-th>
                <vs-th>From Time</vs-th>
                <vs-th>To Time</vs-th>
                <vs-th>No Of Hours</vs-th>
                <vs-th>Reason</vs-th>
                <vs-th>Approvers</vs-th>
                <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].createdOn">
                        {{data[indextr].createdOn | fulldate}}
                    </vs-td>
                    <!-- <vs-td :data="data[indextr].overtimeTypeId" >
                        {{ overtimeType(data[indextr].overtimeTypeId).overtimeTypeName }}
                    </vs-td> -->
                    <vs-td :data="data[indextr].otDate">
                        {{data[indextr].otDate | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].fromTime">
                        {{data[indextr].fromTime | time }}
                    </vs-td>
                    <vs-td :data="data[indextr].toTime">
                        {{data[indextr].toTime | time }}
                    </vs-td>
                    <vs-td :data="data[indextr].noOfHours">
                        {{data[indextr].noOfHours}}
                    </vs-td>
                    <vs-td :data="data[indextr].reason">
                        {{data[indextr].reason}}
                    </vs-td>
                    <vs-td >
                            <ul class="users-liked user-list">
                                <li :key="indextd" v-for="(user, indextd) in data[indextr].approversOTs">
                                    <vx-tooltip :text="user.approver.fullName">
                                        <vs-avatar v-if="user.approver.photoUrl != ''" class="border-2 border-white border-solid -m-1" size="30px" :src="user.approver.photoUrl" />
                                        <vs-avatar v-else class="border-2 border-white border-solid -m-1" size="30px" :text="user.approver.fullName" :color="user.approver.firstName.length <= 3 ? 'success' : user.approver.firstName.length < 6 ? 'primary' : user.approver.firstName.length < 8 ? 'warning' : user.approver.firstName.length < 10 ? 'danger' : user.approver.firstName.length < 13 ? 'dark' : user.approver.firstName.length < 15? 'success' : 'hex'"/>
                                    </vx-tooltip>
                                </li>
                            </ul>
                        </vs-td>
                        <vs-td  :data="data[indextr].fileId" >
                            <vs-icon v-show="data[indextr].fileId != [] && data[indextr].fileId != null" @click="downloadFile(data[indextr].fileId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                        </vs-td>
                        <vs-td :data="data[indextr].fileId">
                                <span class="flex items-center px-2 py-1 rounded">
                                    <div  :class="onGetStatus(data[indextr]) == 'Approved' ? 'h-3 w-3 rounded-full mr-2 bg-success' : 
                                        onGetStatus(data[indextr]) == 'Partially Approved' ? 'h-3 w-3 rounded-full mr-2 bg-partial' :
                                        onGetStatus(data[indextr]) == 'For Revision' ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                                        onGetStatus(data[indextr]) == 'Retracted' ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                                        onGetStatus(data[indextr]) == 'Denied' ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                                        onGetStatus(data[indextr]) == 'Draft' ? 'h-3 w-3 rounded-full mr-2 bg-draft' :
                                        onGetStatus(data[indextr]) == 'Pending' ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 'h-3 w-3 rounded-full mr-2 bg-danger'"/>
                                        {{onGetStatus(data[indextr])}}
                                </span>
                        </vs-td>
                        <vs-td >
                            <span :data="item" :key="index" v-for="(item, index) in data[indextr].approversOTs">
                                {{ data[indextr].approversOTs[index].comments }}
                            </span>
                        </vs-td>
                        <vs-td >
                            <div class="vx-row">
                                <div class="flex">
                                    <vx-tooltip :text="onGetStatus(data[indextr]) == 'Approved' ? 'Retract' : 
                                        onGetStatus(data[indextr]) == 'Partially Approved' ? 'Retract' :
                                        onGetStatus(data[indextr]) == 'For Revision' ? 'Edit' :
                                        onGetStatus(data[indextr]) == 'Retracted' ? '' :
                                        onGetStatus(data[indextr]) == 'Denied' ? '' :
                                        onGetStatus(data[indextr]) == 'Draft' ? 'Edit' :
                                        onGetStatus(data[indextr]) == 'Pending' ? 'Un-Submit' : ''">
                                            <feather-icon v-show="(onGetStatus(data[indextr]) == 'Approved' || onGetStatus(data[indextr]) == 'Partially Approved')  " icon="RepeatIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onRetracted(data[indextr].employeeFiledOvertimeId, data[indextr].approversOTs)" />
                                            <!-- <feather-icon v-show="(onGetStatus(data[indextr]) == 'Approved' || onGetStatus(data[indextr]) == 'Partially Approved') && getFromDate(data[indextr].fromDate) > getCurrentDate " icon="RepeatIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onRetracted(data[indextr].employeeFiledLeaveId)" /> -->
                                            <feather-icon v-show="onGetStatus(data[indextr]) == 'Draft' || onGetStatus(data[indextr]) == 'For Revision'" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onEditRecord(data[indextr].employeeFiledOvertimeId)" />
                                            <feather-icon v-show="onGetStatus(data[indextr]) == 'Pending'" icon="RotateCcwIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onUnSubmit(data[indextr].employeeFiledOvertimeId, data[indextr].approversOTs)" />
                                    </vx-tooltip>
                                    </div>
                                <div class="flex">
                                    <vx-tooltip text="Cancel">
                                        <feather-icon v-show="onGetStatus(data[indextr]) != 'Denied' && onGetStatus(data[indextr]) != 'Retracted' && onGetStatus(data[indextr]) != 'Cancelled'" icon="XIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="onCancelled(data[indextr].employeeFiledOvertimeId, data[indextr].approversOTs)" />        
                                    </vx-tooltip>
                                </div>
                            </div>
                        </vs-td>
                </vs-tr>
            </template>
        </vs-table>

    </vx-card>


    
        <!-- ADD OVERTIME -->
        <vs-prompt
            class="email-compose"
            title="Apply Overtime"
            accept-text= "Submit"
            @accept="onAddOvertime"
            :is-valid="validForm"
            :active.sync="activePromptAddOvertime">
            <vx-card title="Fill-out the following information">
                 <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent>
                        <!-- <div class="vx-row mb-3">
                            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                                <span  class="text-sm">Overtime Type</span><span style="color:red">*</span>
                                <v-select v-validate="'required'" name="overtime type" v-model="overtimeTypeName" label="overtimeTypeName" :options="getOvertimeTypes"/>
                            
                            </div>
                        </div> -->
                        <div class="vx-row mb-3">
                            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                                <span  class="text-sm">Date</span><span style="color:red">*</span>
                                <datepicker v-validate="'required'" :format="format" v-model="employeeOvertime.otDate"></datepicker>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">From Time</span><span style="color:red">*</span>
                                <flat-pickr v-validate="'required'"  name="start-date" class="w-full" v-model="employeeOvertime.fromTime" :config="configFromdateTimePicker"  />
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">To Time</span><span style="color:red">*</span>
                                <flat-pickr v-validate="'required'"  name="end-date" class="w-full" v-model="employeeOvertime.toTime"  :config="configTodateTimePicker"  />
                            </div>
                        </div>
                        
                        <div class="vx-row mb-3">              
                            <div class="vx-col sm:w-3/4  mb-2" > 
                                <span  class="text-sm">No of Hours : </span>
                                <vs-input v-validate="'max_value:24'" v-model="employeeOvertime.noOfHours"/>
                            
                                <!-- <span class="text-white bg-primary p-2 rounded" v-if="noOfHours > 1"> {{noOfHours}} days</span><span class="text-white bg-primary p-2 rounded" v-else>{{noOfHours}} day</span> -->
                            </div>
                        </div>
                        <div class="vx-row mb-3">  
                            <div class="vx-col w-full mb-2">
                                <span  class="text-sm">Reason</span><span style="color:red">*</span>
                                <vs-input name="reason" v-validate="'required'" class="w-full" placeholder="Reason" v-model="employeeOvertime.reason"></vs-input>
                                <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <span class="text-sm">Approvers</span><span style="color:red">*</span>
                                 <v-select name="approvers" v-validate="'required'" multiple :closeOnSelect="false" class="w-full" v-model="approverName" label="fullName" :options="getApprovers" />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <vs-checkbox color="rgb(21, 67, 252)" v-model="employeeOvertime.isDraft">Save As Draft?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-row mb-2" >
                            <div class="vx-col w-full mb-2">
                                <vs-upload
                                    class="compose-mail-attachment"  
                                    ref="uplodfle" 
                                    limit = 2
                                    @on-success="onSuccessUpload"
                                    @on-delete="onDeleteFile"
                                    multiple text="Attachments" 
                                    :show-upload-button="false" 
                                    :headers="{'Content-Type': 'multipart/form-data'}"
                                    accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar" 
                                />
                            </div>
                        </div>
                    </form>
                </component>
            </vx-card>
        </vs-prompt>




        <!-- EDIT OVERTIME -->
         <vs-prompt
            class="email-compose"
            title="Apply Overtime"
            accept-text= "Submit"
            @accept="onUpdateOvertime"
            :is-valid="validForm"
            :active.sync="activePromptEditOvertime">
            <vx-card title="Fill-out the following information">
                 <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent>
                        <!-- <div class="vx-row mb-3">
                            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                                <span  class="text-sm">Overtime Type</span><span style="color:red">*</span>
                                <v-select v-validate="'required'" name="overtime type" v-model="overtimeTypeName" label="overtimeTypeName" :options="getOvertimeTypes"/>
                            
                            </div>
                        </div> -->
                        <div class="vx-row mb-3">
                            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                                <span  class="text-sm">Date</span><span style="color:red">*</span>
                                <datepicker v-validate="'required'" :format="format" v-model="employeeOvertime.otDate"></datepicker>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">From Time</span><span style="color:red">*</span>
                                <flat-pickr v-validate="'required'"  name="start-date" class="w-full" v-model="employeeOvertime.fromTime" :config="configFromdateTimePicker"  />
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">To Time</span><span style="color:red">*</span>
                                <flat-pickr v-validate="'required'"  name="end-date" class="w-full" v-model="employeeOvertime.toTime"  :config="configTodateTimePicker"  />
                            </div>
                        </div>
                        
                        <div class="vx-row mb-3">              
                            <div class="vx-col sm:w-3/4  mb-2" > 
                                <span  class="text-sm">No of Hours : </span>
                                <vs-input v-validate="'max_value:24'" v-model="employeeOvertime.noOfHours"/>
                            
                                <!-- <span class="text-white bg-primary p-2 rounded" v-if="noOfHours > 1"> {{noOfHours}} days</span><span class="text-white bg-primary p-2 rounded" v-else>{{noOfHours}} day</span> -->
                            </div>
                        </div>
                        <div class="vx-row mb-3">  
                            <div class="vx-col w-full mb-2">
                                <span  class="text-sm">Reason</span><span style="color:red">*</span>
                                <vs-input name="reason" v-validate="'required'" class="w-full" placeholder="Reason" v-model="employeeOvertime.reason"></vs-input>
                                <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <span class="text-sm">Approvers</span><span style="color:red">*</span>
                                 <v-select name="approvers" v-validate="'required'" multiple :closeOnSelect="false" class="w-full" v-model="approverName" label="fullName" :options="getApprovers" />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <vs-checkbox color="rgb(21, 67, 252)" v-model="employeeOvertime.isDraft">Save As Draft?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-row mb-2" >
                            <div class="vx-col w-full mb-2" :key="index"  v-for="(attachment, index) in  attachmentName">
                                <vs-button v-show="!isFileReplaced" @click="downloadFile(attachment.value)" color="primary" type="border" :badge=3 icon-pack="feather" icon="icon-download">{{attachment.label}}</vs-button>
                            </div>
                            
                        </div>
                    </form>
                </component>
            </vx-card>
        </vs-prompt>
        
    </div>


    
</template>

<script>
import Datepicker   from 'vuejs-datepicker'
import { en, he }   from 'vuejs-datepicker/src/locale'

import moment       from 'moment'
import vSelect      from 'vue-select'

import flatPickr    from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import Swal from 'sweetalert2'

export default {
    data() {
         return {
            selected:[],
            employeeOvertime: {
                employeeFiledOvertimeId: null,
                otDate: this.getCurrentDate,
                fromTime: this.getCurrentDate,
                toTime: this.getCurrentDate,
                noOfHours: 0,
                reason: '',
                isDraft: false,
                isSubmitted: true,
                submittedOn: null,
                isCancelled: false,
                cancelledOn: null,
                remarks: '',
                fileId: '',
                photoURL:'',
                createdOn: this.getCurrentDate,
                subscriptionId: '58804fc5-45d5-46cb-a892-09fdda5824b4',
                approversOTs: [],
                
            },
            
            formData: new FormData(),
            dataObject: null,

            configFromdateTimePicker : {     
                // noCalendar: true,             
                enableTime: true,
                time_24hr: true,
                // minDate: new Date().fp_incr(false),
                maxDate: null,
                    
            },
            configTodateTimePicker: {
                enableTime: true,
                time_24hr: true,
                maxDate: null,
                
            },  

            activePromptAddOvertime: false,
            activePromptEditOvertime: false,
            activeUnSubmitDialog: false,
            activeRetrackDialog: false,
            activeCancelDialog: false,

            attachmentName: '',

            isFileReplaced: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.30
            },
            format: "d MMMM yyyy",
         }   
    },
    created(){
        
        const data = {
            module: 3,
            userId: this.$store.state.AppActiveUser.uid
        }
        this.$store.dispatch('overtime/getAllApproversByModule', data)
            .then((res) => {
                if(res.data.data.length == 0){
                    this.$alert('Approvers has not been set', 'Leave Request', 'error');
                }
            })
            .catch((err) => { console.log(err)})

        this.$vs.loading()
                const payload = {
                    sortBy: 'OTDate',
                    sortOrder: 'Desc',
                    pageNumber: 1,
                    pageSize: -1,
                    isApprover: false
                }
                this.$store.dispatch('overtime/getAllEmployeeOvertime', payload)
                    .then((res) => { this.$vs.loading.close() })
                    .catch((err) => { this.$vs.loading.close()
                                    console.log(err) })
    },
    
    computed: {
        getEmployeeOvertimeRequests (){
            return this.$store.state.overtime.employeeFiledOvertime
        },
        
        getApprovers(){
            let approver = []
            this.$store.state.overtime.approvers.forEach(a => {
                approver.push(a.approver)
            })
            return approver
        },
        validForm() {

            const x = JSON.parse(JSON.stringify(this.approverName))
            console.log(x.length)
            return  this.employeeOvertime.otDate != '' &&
            this.employeeOvertime.fromTime != '' && 
            this.employeeOvertime.toTime != ''  && 
            this.employeeOvertime.noOfHours != 0 &&
            this.employeeOvertime.reason != '' &&
             x.length > 0
        },
        
        approverName: {
            get() { let approversName = [] 
                    let approvers = this.employeeOvertime.approversOTs
                    approvers.forEach(a => {
                        approversName.push(this.$store.getters['overtime/approverName'](a).approver)
                    })
                return  approversName },
            set(obj) { 
                let approver = []
                this.employeeOvertime.approversOTs =[] 
                        obj.forEach(u => {
                            approver.push(u.userId)
                         })
                this.employeeOvertime.approversOTs = approver
            }
        },
        tenantName: {
            get() { return this.$store.getters['tenants/tenantName'](this.employeeOvertime.tenantsId)  },
            set(obj) { this.employeeOvertime.tenantsId = obj.tenantsId }
        },
        getCurrentDate() {
            return moment(new Date()).utc().format("YYYY-MM-DD")
        },
        scrollbarTag () { return this.$store.getters.scrollbarTag },
        onGetStatus() {
             return (data) => {
                var overtimeStatus = ''
                var c = data.approversOTs.length
                data.approversOTs.forEach((a) => {
                    if(a.isApproved && a.priorityId == 1){
                        if(c > 1) {
                            overtimeStatus = 'Partially Approved'
                        }
                        else
                            overtimeStatus = 'Approved'
                    } else if(a.isApproved && a.priorityId == 2){
                        if(c > 2) {
                            overtimeStatus = 'Partially Approved'
                        }
                        else
                            overtimeStatus = 'Approved'
                    }else if (data.isCancelled) {
                        overtimeStatus = 'Cancelled'
                    } else if(a.isRevised) { 
                        overtimeStatus = 'For Revision'
                    }else if(data.isRetracted) { 
                        overtimeStatus = 'Retracted'
                    }else if(a.isDenied) { 
                        overtimeStatus = 'Denied'
                    }else if (data.isDraft) {
                        overtimeStatus = 'Draft'
                    }else if (data.isSubmitted && overtimeStatus == '') {
                        overtimeStatus = 'Pending'
                    }
                })
                return overtimeStatus
             }
        },
    },
    watch: {
        
        'employeeOvertime.otDate'() {
            this.employeeOvertime.fromTime = this.employeeOvertime.otDate
            this.employeeOvertime.toTime = this.employeeOvertime.otDate
            
        },
        'employeeOvertime.fromTime'() {
            // this.otDate = this.fromTime
            this.getDateDiff()
        },
        'employeeOvertime.toTime'() {
            this.getDateDiff()
        },
        // noOfHours() {
        //     if((this.toTime - this.fromTime) < 0 ){
        //         return 0
        //     }
        //     return this.toTime - this.fromTime
        // },
        'employeeOvertime.isDraft'() {
            if(!this.employeeOvertime.isDraft) {
                this.employeeOvertime.isSubmitted = true
                this.employeeOvertime.submittedOn = new Date()
            }
        },
    },
    methods: {
        promptAddNewOvertime() {
            this.disabledFrom = false
            this.getDefaultApprover()
            this.activePromptAddOvertime = true
        },
        onAddOvertime() {
            this.setFormData()
            this.uploadFiles()
        },
        uploadFiles() {
            this.$vs.loading()
            if(this.countFiles() > 0) {
                this.$store.dispatch('uploadFile', this.formData)
                    .then((response) => {
                        this.$vs.loading.close()
                        if(response.status == 200){
                            this.employeeOvertime.fileId = response.data.item2
                            this.addOvertime()
                        }
                            
                    })
                    .catch((error) => {
                        this.$vs.loading.close()
                        console.log(error.message)
                        
                        
                    })
            this.$vs.loading.close()
            }
            else
                this.addOvertime()
        },
        clearFields() {
            this.toTime = this.reason = ""
            this.photoId = null
            // this.labelLocal = "pending";
        },
        getFromDate(fromDate){
            return moment(fromDate).format('YYYY-MM-DD HH:mm')
        },
        addOvertime() {

            // Loading
            this.$vs.loading()

            if(this.isDraft) {
                this.employeeOvertime.isDraft = true
                this.employeeOvertime.isSubmitted = false
                this.employeeOvertime.submittedOn = null
            }else {
                this.employeeOvertime.submittedOn = new Date()
            }
           
            this.$store.dispatch('overtime/addOvertime', this.employeeOvertime)
            .then(() => {
                
                this.$vs.loading.close()
                if(this.isDraft){
                    this.$alert("You have successfully save your overtime request as draft", 'Draft Save Successfully', "success")
                }else {
                    this.$alert("You have successfully submitted your overtime request", 'Overtime Submitted', "success")
                }
            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                    title: 'Error',
                    text: error.message,
                    iconPack: 'feather',
                    icon: 'icon-x-octagon',
                    color: 'danger'
                })
            })

            
        },
        onEditRecord(filedOvertimeId) {
            this.clearFields()
            const e = this.$store.getters['overtime/employeeFiledOvertime'](filedOvertimeId) 

            this.employeeOvertime.employeeFiledOvertimeId = e.employeeFiledOvertimeId,
            this.employeeOvertime.otDate = e.otDate,
            this.employeeOvertime.fromTime = e.fromTime,
            this.employeeOvertime.toTime = e.toTime,
            this.employeeOvertime.noOfHours= e.noOfHours,
            this.employeeOvertime.reason= e.reason,
            this.employeeOvertime.isDraft= e.isDraft,
            this.employeeOvertime.isSubmitted= e.isSubmitted,
            this.employeeOvertime.submittedOn= e.submittedOn,
            this.employeeOvertime.isCancelled= e.isCancelled,
            this.employeeOvertime.cancelledOn= e.cancelledOn,
            this.employeeOvertime.remarks = e.remarks,
            this.employeeOvertime.fileId= e.fileId,
            this.employeeOvertime.subscriptionId= e.subscriptionId,
            this.employeeOvertime.approversOTs = e.approversOTs.map(u => u.approverId).join(',').split(',')

            if(e.fileId != '')
            this.getAttachmentName(e.fileId.split(','))
            this.activePromptEditOvertime = true
               
        },
        onUpdateOvertime() {
            this.$vs.loading()
            this.$store.dispatch('overtime/updateOvertime', this.employeeOvertime)
            .then(() => {
                this.$vs.loading.close()
                if(this.isDraft){
                    this.$alert("You have successfully updated your overtime request and saved as draft", 'Draft Save Successfully', "success")
                }else {
                    this.$alert("You have successfully submitted your overtime request", 'Overtime Submitted', "success")
                }
                
            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                    title: 'Error',
                    text: error.message,
                    iconPack: 'feather',
                    icon: 'icon-x-octagon',
                    color: 'danger'
                })
            })
        },
        onUnSubmit(filedOvertimeId, approvers) {
             Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "",
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Un-Submit'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    const data = {
                        employeeFiledOvertimeId: filedOvertimeId,
                        action: "UNSUBMIT", 
                        isDraft : true, 
                        isSubmitted: false,
                        approverId: approvers.map(u => u.approverId).join(',')
                    }
                    this.$store.dispatch('overtime/unSubmit', data)
                    .then(() => { 
                            this.$vs.loading.close()
                            this.$alert("You have successfully un-submit your overtime request", 'Un-Submit Successfully', "success")
                        })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error") 
                        })
                } else
                    this.$alert("", 'Cancelled', "success")
            })


        },
        onRetracted(filedOvertimeId, approvers) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "You will not be able to revert this, but you can still use the same date unless denied or taken",
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Retract',
               inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.$vs.loading()
                this.employeeOvertime.remarks = result.value
                const data = {
                        employeeFiledOvertimeId: filedOvertimeId,
                        action: "RETRACKED", 
                        isDraft : false, 
                        isRetracted : true, 
                        retractedOn : this.getCurrentDate, 
                        isApproved: false,
                        remarks : this.employeeOvertime.remarks, 
                        approverId: approvers.map(u => u.approverId).join(',')
                    }
                    this.$store.dispatch('overtime/onRetracked', data)
                    
                    .then(() => { 
                            this.$vs.loading.close()
                            this.$alert("You have successfully retracted your overtime request", 'Retracted Successfully', "success")
                        })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error") 
                        })
                } else
                    this.$alert("", 'Cancelled', "success")
            })

        },
        onCancelled(filedOvertimeId, approvers) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text:'',
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Cancel Request',
              inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }

            }).then((result) => {
              if (result.isConfirmed) {
                    this.$vs.loading()
                    this.employeeOvertime.remarks = result.value
                    const data = {
                        employeeFiledOvertimeId: filedOvertimeId,
                        action: "CANCELLED", 
                        isDraft : false, 
                        isSubmitted: false, 
                        isCancelled : true, 
                        cancelledOn : this.getCurrentDate, 
                        isRevised : false, 
                        remarks : this.employeeOvertime.remarks, 
                        approverId: approvers.map(u => u.approverId).join(',')
                    }
                    this.$store.dispatch('overtime/onCancelled', data)
                
                    .then(() => { 
                            this.$vs.loading.close()
                            this.$alert("You have successfully cancelled your overtime request", 'Cancelled Successfully', "success")
                    })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                        })
                } else
                    this.$alert("", 'Cancelled', "info")
            })


        },
        setFormData(){

            this.formData = new FormData()
            let file = Array.from(this.$refs.uplodfle.filesx)
            // console.log(this.$refs.uplodfle)

            file.forEach(f => {
                if(f.type === 'application/x-msdownload') {
                    this.$vs.notify({
                        title: 'Info',
                        text: "File not allowed",
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'warning'
                        })
                    return
                }
                
                if(!f.remove)
                {   
                    this.formData.append('UserId',  this.$store.state.AppActiveUser.uid)
                    this.formData.append('Title', f.name + '_' + f.type)
                    this.formData.append('Description', this.employeeOvertime.reason)
                    this.formData.append('Path', "")
                    this.formData.append('BlobContainer', "")
                    this.formData.append('OrigFilename', f.name)
                    this.formData.append('ContentType', f.type)
                    this.formData.append('Tags', "")
                    this.formData.append('file', f)

                }

            })
        },
        onSuccessUpload(event) {
            this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
        },
        onDeleteFile() {
        },
        downloadFile(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName.replace('"', '').replace('"', '')
                    // link.setAttribute('download', fileName )
                    // document.body.appendChild(link);
                    link.click();
                })
        },
        getAttachmentName(fileId){
            this.attachmentName = []
            fileId.forEach(f => {
                // console.log(f)
                this.$store.dispatch('downloadFile', f)
                .then((response) => {
                    // console.log('GETATTACHMENT')
                    // console.log(response)
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    let fId = response.config['url'].split('/api/file/download?fileId=')[1]
                    this.attachmentName.push({value: fId, label: fileName.replace('"', '').replace('"', ''),})
                    
                })
            })
        },
        getDefaultApprover() {
            var approver = this.getApprovers
            this.approverName = approver
        },
        getDateDiff(){
            

            if (this.employeeOvertime.fromTime !== '' && this.employeeOvertime.toTime !== '') {
                var date1 = new Date(moment(this.employeeOvertime.fromTime).format("YYYY-MM-DD HH:mm"))
                var date2 = new Date(moment(this.employeeOvertime.toTime).format("YYYY-MM-DD HH:mm"))
                var timeDiff = moment.duration(moment(date2).diff(moment(date1))).asHours()
                if (timeDiff !== 'NaN') {
                    this.employeeOvertime.noOfHours = timeDiff//moment.duration(timeDiff).asHours()
                }
            }



        },
        countFiles() {
            var count = 0
            let file = Array.from(this.$refs.uplodfle.filesx)
            file.forEach(f => {
                if(!f.remove)
                {   
                   count += 1
                } 
                console.log(f)
            })
            return count
        },
        onDisabledDates(){
            //console.log('START')
            this.disabledDates =[]
            let x = 0
            let y = 0
            let ranges = []

            var overtime = this.getEmployeeOvertimeRequests

            overtime.forEach(l => {
                 l.approversLMs.forEach(a => {
                     if(!a.isDenied && !l.isCancelled) 
                    {
                         if(moment(l.fromDate).format('YYYY-MM-DD') == moment(this.employeeOvertimes.fromDate).format('YYYY-MM-DD') && moment(l.toDate).format('YYYY-MM-DD') == moment(this.employeeOvertimes.toDate).format('YYYY-MM-DD'))
                        {
                        
                        } else {
                            x = moment(l.fromDate, 'YYYY-MM-DD')
                            y = moment(l.toDate, 'YYYY-MM-DD')
                            // y = moment(l.toDate, 'YYYY-MM-DD').add(1, 'days')

                            ranges.push({ 
                                from : new Date(moment(x).format('YYYY'), moment(x).add(-1, 'M').format('M'), moment(x).format('DD')),
                                to : new Date(moment(y).format('YYYY'), moment(y).add(-1, 'M').format('M') , moment(y).format('DD'))
                            })
                        }
                    }
                 })
            })

            this.configFromdateTimePicker.disable = JSON.parse(JSON.stringify(ranges))
            this.configTodateTimePicker.disable = JSON.parse(JSON.stringify(ranges))
            
            // this.disabledDates = {
            //     disabledDates: {
            //         ranges: ranges,
            //     }
            // }
        },
        
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>